export class SiteHealthCategory {
    Id: number;
    Name: string;
    TitleInfo: string;
    SafeName: string;
    SortById: number;
    IsArchived: boolean;

    constructor() {
        this.Id = 0;
        this.Name = '';
        this.TitleInfo = '';
        this.SafeName = '';
        this.SortById = 0;
        this.IsArchived = false;
    }
}

export class SiteHealthMetric {
    Id: number;
    SiteHealthCategoryId: number;
    CategoryName?: string;
    Name: string;
    TitleInfo: string;
    VariableName: string;
    IsPercent: boolean;
    SiteHealthMetricScalingId: number;
    ScalingName?: string;
    ScalingValueCount: number;
    ScalingValue1: number | null;
    ScalingValue2: number | null;
    ScalingValue3: number | null;
    ScalingValue4: number | null;
    SortById: number;
    IsArchived: boolean;

    constructor() {
        this.Id = 0;
        this.SiteHealthCategoryId = 0;
        this.Name = '';
        this.TitleInfo = '';
        this.VariableName = '';
        this.IsPercent = false;
        this.SiteHealthMetricScalingId = 0;
        this.ScalingValueCount = 2;
        this.ScalingValue1 = null;
        this.ScalingValue2 = null;
        this.ScalingValue3 = null;
        this.ScalingValue4 = null;
        this.SortById = 0;
        this.IsArchived = false;
    }
}

export class SiteHealthMetricScaling {
    Id: number;
    Name: string;
    SortById: number;
    IsArchived: boolean;

    constructor() {
        this.Id = 0;
        this.Name = '';
        this.SortById = 0;
        this.IsArchived = false;
    }
}

export class SiteHealthMetricMetaData {
    VariableName: string;
    VariableName2: string;
    MetricName: string;
    Description: string;
}